import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "timeline-header block relative" }
const _hoisted_2 = { class: "font-normal text-center bg-skin text-black20 -mt-3 pt-2" }
const _hoisted_3 = {
  key: 0,
  class: "font-normal text-center text-skin"
}

import { withDefaults, computed } from "vue";
import { get, useDateFormat } from "@vueuse/core";
import { BookingViewTypeEnum } from "@/clinic/typings/enums/booking";
import { DAY_JP_FORMAT, LOCALE, TIME_FORMAT } from "@/clinic/typings/constants/booking";

type ITimeLine = {
  date: Date;
  viewType: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'timeline',
  props: {
    date: null,
    viewType: null
  },
  setup(__props: any) {

const props = __props as { date: Date, viewType: string };



const timelineHeader = computed((): string => {
  switch (props.viewType) {
    case BookingViewTypeEnum.Week:
      return get(useDateFormat(props.date, DAY_JP_FORMAT, { locales: LOCALE }));
    default:
      return get(useDateFormat(props.date, TIME_FORMAT));
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(get)(_unref(timelineHeader))), 1),
    (__props.viewType != _unref(BookingViewTypeEnum).Day)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(get)(_unref(timelineHeader))), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})